import { render, staticRenderFns } from "./GainerCoin.vue?vue&type=template&id=b6bd12dc&scoped=true"
import script from "./GainerCoin.vue?vue&type=script&lang=js"
export * from "./GainerCoin.vue?vue&type=script&lang=js"
import style0 from "./GainerCoin.vue?vue&type=style&index=0&id=b6bd12dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bd12dc",
  null
  
)

export default component.exports